import React from "react";
import Container from "@/components/marketing/Container";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Check, ArrowRight, Sparkles } from "lucide-react";

const INCLUDED = [
  "Entity building across Google's trusted sources",
  "Verified profiles and authoritative references",
  "Structured data and schema markup guidance",
  "Ongoing signal reinforcement until the panel appears",
  "Dedicated specialist managing the process end-to-end",
];

export default function KnowledgePanelFeature() {
  return (
    <section id="knowledge-panel" className="py-7 sm:py-9 lg:py-12 bg-canvas scroll-mt-24">
      <Container>
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div>
            <span className="meta-tag inline-block mb-4">FLAGSHIP</span>
            <h2 className="font-heading text-3xl sm:text-4xl font-bold text-bone leading-tight mb-4">
              Google Knowledge Panel creation
            </h2>
            <p className="text-steel text-base lg:text-lg leading-relaxed mb-6">
              A Knowledge Panel is the information box Google shows on the right of search results for notable people and brands. We build the entity signals, authoritative references, and verified profiles Google needs to generate one for you.
            </p>
            <div className="flex items-baseline gap-3 mb-6">
              <span className="font-heading text-4xl font-bold text-cobalt">$2,500</span>
              <span className="text-steel text-sm">per Knowledge Panel engagement</span>
            </div>
            <Link to="/contact">
              <Button size="lg" className="bg-cobalt hover:bg-cobalt/90 text-white font-medium px-8 py-6 text-base">
                Enquire about a Knowledge Panel <ArrowRight className="ml-2 w-4 h-4" />
              </Button>
            </Link>
          </div>
          <div className="bg-white border border-[#e8e6ef] rounded-xl p-8 shadow-sm">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-full bg-cobalt/10 flex items-center justify-center">
                <Sparkles className="w-5 h-5 text-cobalt" />
              </div>
              <h3 className="font-heading text-lg font-semibold text-bone">What's included</h3>
            </div>
            <ul className="space-y-4">
              {INCLUDED.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <Check className="w-5 h-5 text-cobalt shrink-0 mt-0.5" />
                  <span className="text-sm text-prose leading-relaxed">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Container>
    </section>
  );
}